<template>
    <div>
        <LoadingVue :isLoading="isLoading" :key="isLoading"/>
        
        <div :class="view_class_view.div_container" class="grid grid-cols-1">
            <div v-show="form_visibility.company" class="my-2">
                <label for="input_company">Empresa donde trabaja:</label>
                <input type="text" id="input_company" name="input_company" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: laborInformationModelValidations.company.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!laborInformationModelValidations.company.$invalid, [view_class_view.class_inputs.default ]: laborInformationModelValidations.company.$invalid && !laborInformationModelValidations.company.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="laborInformationModel.company" @blur="laborInformationModelValidations.company.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of laborInformationModelValidations.company.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div v-show="form_visibility.occupation" class="my-2">
                <label for="input_occupation">Ocupación:</label>
                <input type="text" id="input_occupation" name="input_occupation" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: laborInformationModelValidations.occupation.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!laborInformationModelValidations.occupation.$invalid, [view_class_view.class_inputs.default ]: laborInformationModelValidations.occupation.$invalid && !laborInformationModelValidations.occupation.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="laborInformationModel.occupation" @blur="laborInformationModelValidations.occupation.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of laborInformationModelValidations.occupation.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div v-show="form_visibility.anual_income" class="my-2">
                <label for="input_anual_income">Ingresos Anuales:</label>
                <input v-money="money" type="text" id="input_anual_income" name="input_anual_income" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: laborInformationModelValidations.annual_income.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!laborInformationModelValidations.annual_income.$invalid, [view_class_view.class_inputs.default ]: laborInformationModelValidations.annual_income.$invalid && !laborInformationModelValidations.annual_income.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="laborInformationModel.annual_income" @blur="laborInformationModelValidations.annual_income.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of laborInformationModelValidations.annual_income.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import LoadingVue from '../VueLoading.vue';
import { helpers, requiredIf } from "@vuelidate/validators";
import { VMoney } from "v-money";

export default {
    name: 'IssuanceLaborInformation',
    props: {
        form_visibility:{
            type: Object,
            required: false,
            default(){
                return {
                    company: true,
                    occupation: true,
                    anual_income: true
                }
            }
        },
        view_class_view: {
            type: Object,
            required: true,
            default(){
                return {
                    class_inputs:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
                }
            }
        },
        validations: {
            type: Object,
            required: true,
            default() {
                return {
                    street: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    suburb: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    ext_number: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    int_number: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    postal_code: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    }
                };
            }
        }
    },
    setup(props) {

        let isLoading = ref(false);
        let laborInformationModel = ref({
            company: "",
            occupation: "",
            annual_income: ""
        });

        const money = ref({
            decimal: '.',
            thousands: ',',
            prefix: '$ ',
            precision: 2,
            masked: false
        });

        const laborInformationModelValidations = useVuelidate(props.validations, laborInformationModel);
       
        function execute_validation() {
            laborInformationModelValidations.value.$validate();
            if(laborInformationModelValidations.value.$error)return null;
            laborInformationModel.value.annual_income = removeDollarSignAndzeros(laborInformationModel.value.annual_income);
            return laborInformationModel.value;
        }

        function removeDollarSignAndzeros(number) {
            // Eliminar el signo
            number = number.replace('$', '').replace(',', '').trim();
            return number;
        }

        return {
            isLoading,
            laborInformationModel,
            laborInformationModelValidations,
            execute_validation,
            money
        }
    },
    directives: { money: VMoney },
    components: {
        LoadingVue
    }
}

</script>